export default __webpack_public_path__ + "static/media/wk-360.112c2a5b.png";